(() => {
  const normalize = (value) =>
    String(value || '')
      .toLowerCase()
      .replace(/%2f/g, '-')
      .replace(/\//g, '-')
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9.-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');

  const baseSku = (sku) => String(sku || '').split('/')[0];

  const updateSkuText = (variant) => {
    document.querySelectorAll('[data-alliance-selected-sku]').forEach((element) => {
      const strong = element.querySelector('strong');
      if (strong) strong.textContent = variant?.sku || variant?.title || '';
    });
  };

  const scoreImage = (image, sku, base) => {
    const holder = image.closest('[data-alliance-media-alt]');
    const source = normalize(`${holder?.dataset.allianceMediaAlt || ''} ${image.currentSrc || image.src || ''} ${image.alt || ''}`);
    const fullSku = normalize(sku);
    const baseOnly = normalize(base);
    let score = 0;

    if (fullSku && source.includes(fullSku)) score += 100;
    if (baseOnly && source.includes(baseOnly)) score += 60;
    if (source.includes(`__${fullSku}__2`) || source.includes(`__${baseOnly}-ws__2`) || source.includes(`__${baseOnly}-gs__2`)) {
      score += 80;
    }
    if (source.includes('dimension') || source.includes('description') || source.includes('size')) score += 40;
    if (source.includes(`__${fullSku}__1`) || source.includes(`__${baseOnly}-ws__1`) || source.includes(`__${baseOnly}-gs__1`)) {
      score += 10;
    }
    if (source.includes(baseOnly) && source.includes(' x ')) score += 35;

    return score;
  };

  const activateVariantMedia = (variant) => {
    if (!variant?.sku) return;

    const gallery = document.querySelector('media-gallery');
    const thumbnails = [...document.querySelectorAll('.thumbnail-list__item .thumbnail img')];
    if (!gallery || !thumbnails.length) return;

    const sku = variant.sku;
    const base = baseSku(sku);
    const best = thumbnails
      .map((image) => ({ image, score: scoreImage(image, sku, base) }))
      .filter((item) => item.score > 0)
      .sort((a, b) => b.score - a.score)[0];

    const button = best?.image?.closest('button.thumbnail');
    if (button) {
      button.click();
      return;
    }

    if (variant.featured_media?.id && gallery.setActiveMedia) {
      const sectionId = document.querySelector('product-info')?.dataset.section;
      if (sectionId) gallery.setActiveMedia(`${sectionId}-${variant.featured_media.id}`, true);
    }
  };

  const handleVariant = (variant) => {
    updateSkuText(variant);
    window.requestAnimationFrame(() => activateVariantMedia(variant));
  };

  const parseJson = (selector) => {
    try {
      return JSON.parse(document.querySelector(selector)?.textContent || 'null');
    } catch {
      return null;
    }
  };

  const selectedOptions = () =>
    [...document.querySelectorAll('variant-selects fieldset, variant-selects .product-form__input--dropdown')].map(
      (group) => {
        const selected = group.querySelector('input:checked') || group.querySelector('select option:checked');
        return selected?.value || '';
      }
    );

  const variantFromCurrentOptions = () => {
    const variants = parseJson('variant-selects [data-alliance-product-variants]') || [];
    const options = selectedOptions();
    return variants.find((variant) => variant.options.every((option, index) => option === options[index]));
  };

  const refreshFromDom = () => {
    const variant = variantFromCurrentOptions() || parseJson('variant-selects [data-selected-variant]');
    if (variant) handleVariant(variant);
  };

  document.addEventListener('DOMContentLoaded', refreshFromDom);
  document.addEventListener('change', (event) => {
    if (!event.target.closest('variant-selects')) return;
    window.setTimeout(refreshFromDom, 80);
  });
  document.addEventListener('click', (event) => {
    const label = event.target.closest('variant-selects label');
    if (!label) return;
    window.setTimeout(refreshFromDom, 120);
  });
})();
